/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

export const stringify = (obj: Record<string, any>) =>
  Object.keys(obj)
    .map((key) => `${key}=${encodeURIComponent(obj[key])}`)
    .join('&');
